// extracted by mini-css-extract-plugin
export default {"showcase":"AboutUs_showcase__dGXgf","overlay":"AboutUs_overlay__u-b0k","Margin2":"AboutUs_Margin2__lM-qP","H3":"AboutUs_H3__surOG"};